import React from 'react';
import { Col } from 'react-bootstrap';

export const Step = (props) => {
	const { title, image, count } = props;
	return (
		<Col className="work-step" md={4} sm={6} xs={12}>
			<div className="inner-box">
				<figure className="icon-box wow zoomInStable" {...props}>
					<img src={require('../../../assets/images/steps')[image]} alt={title} />
				</figure>
				<h3><span className="count">{count}</span>{title}</h3>
			</div>
		</Col>
	)
};



// WEBPACK FOOTER //
// ./src/components/ui/Steps/Step.js